import { RootState } from '../../Store';
import { useSelector } from 'react-redux';

export const useGetPrintButtonEnabled = (): boolean =>
    useSelector<RootState, boolean>(state => state.pdf.buttonEnabled);
